import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7fb3830"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "pie-progress" }
const _hoisted_2 = { id: "percentage" }


  import { useStore } from "vuex";

  
    const __default__ = {
        name: 'MainProgress',
        inheritAttrs: false,
        customOptions: {}
    }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    percentage: Number, 
    borderThickness: Number, 
    mainColor: String, 
    width: Number,
    fontSize: String
  },
  setup(__props) {

const props = __props;

_useCssVars(_ctx => ({
  "2383fd60": (props.width),
  "e1855078": (props.mainColor),
  "215bd340": (props.percentage),
  "79c0f640": (__props.borderThickness),
  "65447316": (props.fontSize)
}))


  const globalStore = useStore();
  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.percentage) + "% ", 1)
  ]))
}
}

})